import { getAmplitudeInstance } from '../amplitudeHelpers';
import ShowMoreLocation from '../enums/ShowMoreLocation';

type logTrailDetailsShowMoreClickedParams = {
  show_more_location?: ShowMoreLocation;
  trail_id: number;
};

/**
 * User clicks 'show more' in the first or second description.
 * @param params - Attributes to log with the amplitude event
 * @param params.show_more_location - The location of the 'show more'.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsShowMoreClicked = ({ show_more_location, trail_id }: logTrailDetailsShowMoreClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details show more clicked', { 'show more location': show_more_location, 'trail id': trail_id }, callback);
};

export default logTrailDetailsShowMoreClicked;
